import type { Furniture, Room, Vec2 } from "../types";
import { clampPoseInRoom } from "../interiorWalls";
import { resolveFurniture } from "./resolve";

export type NudgeDirection = "up" | "down" | "left" | "right";

const STEP: Record<NudgeDirection, Vec2> = {
  up: { x: 0, y: -1 },
  down: { x: 0, y: 1 },
  left: { x: -1, y: 0 },
  right: { x: 1, y: 0 },
};

/**
 * Where a nudge arrow puts a piece: `stepIn` inches in a screen direction
 * (the plan is never rotated, so up is -y), kept inside the room the same
 * way a drag is.
 */
export function nudgedPose(
  item: Furniture,
  direction: NudgeDirection,
  stepIn: number,
  room: Room
): Vec2 {
  const d = STEP[direction];
  const next = { x: item.x + d.x * stepIn, y: item.y + d.y * stepIn };
  return clampPoseInRoom(next, resolveFurniture(item).footprint, item.rotation, room);
}
